'use client';
import { subscribe, unsubscribe } from '@/lib/events';
import { Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import customToaster from '../toast/CustomToaster';

const loader: boolean[] = [];

export default function Spinner() {
  // const { isLoading } = useSpinnerContext();

  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    subscribe('startLoading', (e: any) => {
      loader.push(true);
      setIsVisible(true);
    });

    subscribe('stopLoading', (e: any) => {
      loader.pop();
      if (loader?.length === 0) {
        setIsVisible(false);
        if (e.detail?.message) {
          customToaster(e.detail?.message, e.detail?.type);
        }
      }
    });

    return () => {
      unsubscribe('startLoading', (e: any) => {
        loader.push(true);
        setIsVisible(true);
      });
      unsubscribe('stopLoading', (e: any) => {
        loader.pop();

        if (loader?.length === 0) {
          setIsVisible(false);
        }
      });
    };
  }, []);

  return (
    <>
      {isVisible ? (
        <Box className="app-loader">
          <CircularProgress thickness={6.5} />
        </Box>
      ) : null}
    </>
  );
}
